import { useEntitlement } from '@components/entitlements';
import type { TourConfig } from '@features/app-tour/app-tour.models';
import applicationSteps from '@features/app-tour/tour-steps/application-steps';
import artifactAnalysisSteps from '@features/app-tour/tour-steps/artifact-analysis-steps';
import imageSteps from '@features/app-tour/tour-steps/image-steps';
import kubernetesSteps from '@features/app-tour/tour-steps/kubernetes-steps';
import policyEditorSteps from '@features/app-tour/tour-steps/policy-editor-steps';
import policyManagerSteps from '@features/app-tour/tour-steps/policy-manager-steps';
import reportsSteps from '@features/app-tour/tour-steps/reports-steps';
import sbomManagementSteps from '@features/app-tour/tour-steps/sbom-management-steps';
import welcomeSteps from '@features/app-tour/tour-steps/welcome-steps';

export const useTourConfig = (): TourConfig => ({
  '/*': [welcomeSteps()],
  '/policy': [policyManagerSteps()],
  '/policy/:policyId': [policyEditorSteps()],
  '/applications': [applicationSteps()],
  '/inventory/kubernetes': [kubernetesSteps()],
  '/artifacts/image': [
    imageSteps({
      isCloudImage: useEntitlement('crp'),
    }),
  ],
  '/reports': [reportsSteps()],
  '/reports/new': [reportsSteps()],
  '/sboms': [sbomManagementSteps()],
  '/sboms/groups/:groupId/:tab?': [sbomManagementSteps()],
  '/sboms/:sbomId/:revisionId?/:tab?': [sbomManagementSteps()],
  '/artifacts/image/:registry/:repository/:tag/:id': [artifactAnalysisSteps()],
});
